module.exports = __webpack_public_path__ + "img/safety-woman.f46824a0.png";